(function ($) {
  "use strict";

  $(document).ready(function(){

    /*---------------------
 1. slicknav
--------------------- */

    $(".bag-icon").on('click', function(){
      $(this).toggleClass("active");
      $(".shopping-cart").slideToggle(400);
      $(".top-account").css("display","none");
      $(".top-search").css("display","none");
      $(".lock-icon").removeClass("active");
      $(".search-icon").removeClass("active");
    });
    $(".lock-icon").on('click', function(){
      $(this).toggleClass("active");
      $(".top-account").slideToggle(400);
      $(".shopping-cart").css("display","none");
      $(".top-search").css("display","none");
      $(".bag-icon").removeClass("active");
      $(".search-icon").removeClass("active");
    });
    $(".search-icon").on('click', function(){
      $(this).toggleClass("active");
      $(".top-search").slideToggle(400);
      $(".shopping-cart").css("display","none");
      $(".top-account").css("display","none");
      $(".bag-icon").removeClass("active");
      $(".lock-icon").removeClass("active");
    });

    $('#menu-navigation #bs-example-navbar-collapse-1 .Menu.has_dropdown').hover(function(){

      /* get total padding + border + margin of the popup */
      var extraWidth       = 0
      var wrapWidthPopup   = $(this).find('.site-nav__dropdown').outerWidth(true); /*include padding + margin + border*/
      var actualWidthPopup = $(this).find('.site-nav__dropdown').width(); /*no padding, margin, border*/
      extraWidth           = wrapWidthPopup - actualWidthPopup;    

      /* calculate new width of the popup*/
      var new_width_popup = $(this).find('.site-nav__dropdown .even2').outerWidth(true);
      var new_outer_width_popup = $(this).find('.site-nav__dropdown .itemMenu.nochild').outerWidth(true);
      
      var n = $(this).find('.site-nav__dropdown .itemMenu.has_child' ).length;
      if( n > 1){
        new_outer_width_popup = ( new_width_popup + extraWidth ) * n;
        new_width_popup = new_width_popup * n;
      }
      
      /*define top and left of the popup*/
      var wraper = $('#bs-example-navbar-collapse-1');
      var wWraper = wraper.outerWidth();
      var posWraper = wraper.offset();
      var pos = $(this).offset();
      var xLeft = pos.left - posWraper.left;
      if ((xLeft + new_outer_width_popup) > wWraper) xLeft = wWraper - new_outer_width_popup;
      
      var max = Math.abs(xLeft) + new_outer_width_popup;
      if (max > wWraper){
        new_outer_width_popup = wWraper;
        xLeft = 0;
      }
      $(this).find('.site-nav__dropdown').css('left',xLeft);

      /*set new width popup*/
      $(this).find('.site-nav__dropdown').css('width',new_outer_width_popup);

    });
    $(".nav-open").on('click', function(){
      $(".main-menu-area").fadeToggle(1000);
    });
    $(".nav-close").on('click', function(){
      $(".main-menu-area").css("display","none");
    });
    
    /*---------------------
     3. tooltip
    --------------------- */	
    $('[data-toggle="tooltip"]').tooltip(); 
    
    /*---------------------
     4. Nivo navigation
    ----------------------*/
    $('.nivo-directionNav .nivo-nextNav').addClass('hvr-icon-wobble-horizontal hvr-bounce-to-right');
    $('.nivo-directionNav .nivo-prevNav').addClass('hvr-icon-wobble-horizontal hvr-bounce-to-left');
	
    
    /*---------------------
     5. Twitter carousel
    ----------------------*/
    $('#twitter-feed-carosul').owlCarousel({
      singleItem:true,
      autoPlay:true,
      pagination:false,
    });
    
    /*---------------------
     6. Header Page
     ----------------------*/
    $('.breadcrumb span:last-child').each(function(){
      var value=$(this).text();
      $('.shop-header').text(value);
      $('.blog-header').text(value);
    });
    
   var owl = $(".rdcma-carousel-blog");

    owl.owlCarousel({
      items : 2,
      itemsDesktop : [1199,2],
      itemsDesktopSmall : [980,2],
      itemsTablet: [768,1],
      itemsTabletSmall: false,
      itemsMobile : [479,1],
      singleItem : false,
      itemsScaleUp : false,
    });
    
    /*---------------------
      scrollUp
    --------------------- */	
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });	
    /*---------------------
      Popup
    --------------------- */	
    $(document).on('click', '.newsletterbtn', function(event) {
      $('.mc-modal').css({'display':'block','opacity':'1'})
    });	
    
    /*---------------------
      Map
    --------------------- */	
    $('.map-area').click(function () {
      $('.map-area iframe').css("pointer-events", "auto");
    });
    
    $( ".map-area" ).mouseleave(function() {
      $('.map-area iframe').css("pointer-events", "none"); 
    });
    
   }); 

})(jQuery);